import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { EftattachComponent } from './eftattach.component';

const routes: Routes = [
    {
    path: '',
    component: EftattachComponent,
    data: {
        title: 'VA login'
    }
}
];

@NgModule({
    declarations: [EftattachComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,  
    FormsModule,  
    RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EFTAttachModule { }
